export const fieldTypes = {
  CHIP_GROUP: 'chipGroup',
  LIST_PICKER: 'listPicker',
  AUTOCOMPLETE: 'autoComplete',
  SWITCH: 'switch',
  DATE_RANGE_PICKER: 'dateRangePicker',
  TEXT_FIELD: 'textField',
  RADIO_GROUP: 'radioGroup',
};
